// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"1c418e86b251861b5eca","655":"9fa2f1e6feaba5f6767a"}[chunkId] + ".js";
};